import moment from "moment/moment";
import { useMediaQuery } from "react-responsive";
import CuButton from "./CuButton";

const PAppointmentCard = ({
  data,
  onclickRx,
  isLoading,
  showRecipt,
  billLoading,
  appoinmentType,
}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 768 });
  // //(" appointemnt data---------", data);
  return (
    <div className="border-[0.5px] border-[#cecece] p-3 mt-5 rounded flex flex-col gap-4 w-full lg:w-[622.23px] xl:w-[777.79px] large:w-[830.05px] xlarge:w-[1166.68px]">
      <div className="flex items-center gap-3">
        <div className="border h-[88px] w-[82px]">
          <div className="h-full w-full flex justify-center items-center text-3xl font-bold bg-[#C7EAC9] text-white">
            {data ? data?.user_details?.full_name.split("")[0] : ""}
          </div>
        </div>
        <div className="flex-1 mt-[0px] sm:mt-[-13px] lg:p-2 lg:pt-3">
          <div className="flex justify-between mt-1">
            <div className="text-[16px] font-bold leading-[20px] sm:text-[20px]">
              {`Dr. ${data?.doctor_user?.first_name} ${data?.doctor_user?.last_name}`}{" "}
            </div>
            <span>⋮</span>
          </div>
          {/* <div className="text-[#656565]  text-xs font-bold leading-[16px]">
            speciality
          </div> */}
          <div className="block md:flex justify-between items-center">
            <div>
              <div className="">
                <span className=" text-[#4C4C4C] text-sm font-semibold">
                  {moment
                    .utc(data?.start_time)
                    .utcOffset("+0530")
                    .format("DD MMM YY")}{" "}
                  <span>: </span>
                </span>
                <span className="text-[#57D08B] text-sm font-semibold">
                  {moment
                    .utc(data?.start_time)
                    .utcOffset("+0530")
                    .format("hh:mm A")}
                </span>
              </div>
              {data?.custom_field_1 && (
                <div>
                  <span className="text-sm font-semibold">
                    {data?.custom_field_1?.display_name} :{" "}
                  </span>
                  <span className="text-[#4C4C4C] text-sm font-semibold">
                    {data?.custom_field_1?.value}
                  </span>
                </div>
              )}
              {data?.consultation_data[0]?.opd_number && (
                <div>
                  <span className="text-sm font-semibold">OPD Number : </span>
                  <span className="text-[#4C4C4C] text-sm font-semibold">
                    {data?.consultation_data[0]?.opd_number}
                  </span>
                </div>
              )}
              {data?.ipds && (
                <div>
                  <span className="text-sm font-semibold">IPD Number : </span>
                  <span className="text-[#4C4C4C] text-sm font-semibold">
                    {data?.ipds?.ipd_number}
                  </span>
                </div>
              )}
              {/* {isSmallScreen && (
                <div
                  className={` ${
                    data?.status === "booked"
                      ? "text-yellow-500"
                      : "text-[#57D08B]"
                  }`}
                >
                  {data?.status === "booked" ? "Booked" : "Completed"}
                </div>
              )} */}

              {/* {!isSmallScreen && ( */}
              <div className="mt-1">
                <span className=" text-[#999999] text-[16px] font-semibold">
                  {data.is_online
                    ? "Online appointment"
                    : "In-person appointment"}
                </span>
              </div>
              {/* )} */}
            </div>
            {!isSmallScreen && (
              <div className="flex items-center gap-4">
                {(data.status === "completed" ||
                  appoinmentType === "pending") && (
                  <CuButton
                    className={`w-[150px] h-12 rounded border cursor-pointer flex justify-center items-center`}
                    onClick={showRecipt}
                    isLoading={billLoading}
                  >
                    View Recipt
                  </CuButton>
                )}
                {data?.status === "completed" && (
                  <CuButton
                    className={`w-[150px] h-12 rounded border cursor-pointer flex justify-center items-center`}
                    onClick={onclickRx}
                    isLoading={isLoading}
                  >
                    View Rx
                  </CuButton>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {isSmallScreen && data?.status === "completed" && (
        <div className="w-full flex items-center gap-4">
          <div className="w-full">
            {(appoinmentType === "pending" || data?.status === "completed") && (
              <CuButton
                className={`w-full h-12 border flex justify-center items-center rounded`}
                onClick={showRecipt}
                isLoading={billLoading}
              >
                View Recipt
              </CuButton>
            )}
          </div>
          <div className="w-full">
            {data?.status === "completed" && (
              <CuButton
                className={`w-full h-12 border flex justify-center items-center rounded`}
                // onClick={}
                onClick={onclickRx}
                isLoading={isLoading}
              >
                View Rx
              </CuButton>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PAppointmentCard;
